"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Gameday = function Gameday(leftJoker, rightJoker) {
  var buckets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  _classCallCheck(this, Gameday);

  this.leftJoker = leftJoker;
  this.rightJoker = rightJoker;
  this.buckets = buckets;
};

exports["default"] = Gameday;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9nYW1lZGF5LnRzIl0sIm5hbWVzIjpbIkdhbWVkYXkiLCJsZWZ0Sm9rZXIiLCJyaWdodEpva2VyIiwiYnVja2V0cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0lBRXFCQSxPLEdBQ25CLGlCQUFtQkMsU0FBbkIsRUFBZ0RDLFVBQWhELEVBQXdHO0FBQUEsTUFBMUJDLE9BQTBCLHVFQUFKLEVBQUk7O0FBQUE7O0FBQUEsT0FBckZGLFNBQXFGLEdBQXJGQSxTQUFxRjtBQUFBLE9BQXhEQyxVQUF3RCxHQUF4REEsVUFBd0Q7QUFBQSxPQUExQkMsT0FBMEIsR0FBMUJBLE9BQTBCO0FBQUUsQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBNYXRjaCBmcm9tIFwiLi9tYXRjaFwiO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBHYW1lZGF5PFQ+IHtcbiAgY29uc3RydWN0b3IocHVibGljIGxlZnRKb2tlcj86IE1hdGNoPFQ+LCBwdWJsaWMgcmlnaHRKb2tlcj86IE1hdGNoPFQ+LCBwdWJsaWMgYnVja2V0czogTWF0Y2g8VD5bXSA9IFtdKSB7fVxufVxuIl19